import * as React from 'react';

import { MetricsGrey, ThresholdStatus, isThresholdStatus, MetricsDisabled } from '@tableau/metrics-engine';
import { DropdownButtonType, List, SingleSelectDropdown } from '@tableau/widgets';

import { Messages } from '../../../../gen-src/Localize';

export interface StatusDropdownComponentProps {
  testId: string;
  value: ThresholdStatus | null;
  label: string;
  className?: string;
  onChange?: (value: ThresholdStatus) => void;
  disabled?: boolean;
}

export const StatusDropdownComponent = (props: StatusDropdownComponentProps): JSX.Element => {
  const listItems = [
    {
      content: Messages.GoodStatus(),
      value: ThresholdStatus.GOOD,
    },
    {
      content: Messages.NeutralStatus(),
      value: ThresholdStatus.NEUTRAL,
    },
    {
      content: Messages.BadStatus(),
      value: ThresholdStatus.BAD,
    },
  ];

  const handleChange = (value: string) => {
    if (value !== props.value) {
      if (isThresholdStatus(value)) {
        props.onChange?.(value);
      }
    }
  };

  const color = props.disabled ? MetricsDisabled : MetricsGrey;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
      <p style={{ fontSize: 12, fontWeight: 'bold', marginRight: 10, color }}>{props.label}</p>
      <SingleSelectDropdown
        className={props.className}
        testId={props.testId}
        type={DropdownButtonType.Outline}
        label={''}
        list={<List items={listItems} />}
        onChange={handleChange}
        value={props.value ?? ThresholdStatus.NEUTRAL}
        style={{ width: 120 }}
        disabled={props.disabled}
      />
    </div>
  );
};
